import { createContext } from 'react';

/**
 * True while a `LiveCompactCard` is hovered or contains focus. The space-slot
 * content row (`LiveSlotContentRow`) consumes this to PAUSE its rotation (WCAG
 * 2.2.2 pausable). Lives in its own module so both the provider (the card) and
 * the consumer (the row) import it without a component ↔ component cycle, and so
 * the card file exports only components (Fast Refresh).
 */
export const LiveCardPauseContext = createContext(false);
